import axios from "helpers/_axios";
import { STATUS_SENT } from "helpers/fileStatus.json";
import {
  resetPayload as resetRolePayload,
  GET_PERMISSIONS
} from "store/actions/roleAction";
export const LOGIN = "LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";

export const authAction =
  ({ username, password }) =>
  async dispatch => {
    try {
      const response = await axios().post("/auth/login", {
        email: username.trim(),
        password: password.trim()
      });
      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem(
        "logged_user",
        JSON.stringify(response.data.data.user)
      );
      localStorage.setItem("active_tab", STATUS_SENT);
      dispatch({
        type: LOGIN_ERROR,
        httpStatus: 0,
        payload: null
      });
      dispatch({
        type: LOGIN,
        httpStatus: response.data.status,
        payload: response.data.data,
        errors: []
      });
    } catch (error) {
      if (error.response) {
        dispatch({
          type: LOGIN_ERROR,
          httpStatus: error.response.status,
          payload: error.response.data.data
        });
      } else {
        dispatch({
          type: LOGIN_ERROR,
          httpStatus: 500,
          payload: error.message
        });
      }
    }
  };

export const verifyToken = () => async dispatch => {
  // Check if a token is available in the localstorage
  const token = localStorage.getItem("token");

  if (token) {
    try {
      // Run api to verify the token
      const response = await axios().post("/auth/verify", {
        token: token
      });
      return dispatch({
        type: LOGIN,
        httpStatus: response.data.status,
        payload: response.data.data.success,
        errors: []
      });
    } catch (error) {
      // Remove token if not verified and dispatch httpStatus 401
      localStorage.removeItem("token");
      if (error.response) {
        dispatch({
          type: LOGIN,
          httpStatus: error.response.status,
          payload: null,
          errors: [error.response.data.data]
        });
      } else {
        dispatch({
          type: LOGIN,
          httpStatus: 500,
          payload: error.message,
          errors: []
        });
      }
    }
  } else {
    dispatch({
      type: LOGIN,
      httpStatus: 500,
      payload: "Session timedout",
      errors: []
    });
  }
};

export const logout = () => async dispatch => {
  localStorage.removeItem("token");
  localStorage.removeItem("active_tab");
  localStorage.removeItem("logged_user");
  dispatch(resetRolePayload(GET_PERMISSIONS));
  dispatch({
    type: LOGOUT,
    httpStatus: 200,
    payload: null,
    errors: []
  });
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    isAuthenticated: false,
    httpStatus: "",
    payload: "",
    errors: []
  });
};
